import { createContext } from "react";

const EnterProductsContext = createContext();

export default EnterProductsContext;
